export { baseCheckboxPropDefs as checkboxPropDefs } from './base-checkbox.props.js';
